import PropTypes, { arrayOf } from 'prop-types'

const { array, bool, shape, string } = PropTypes

export default shape({
    tags: array,
    rating: string,
    sourceUrl: string,
    termsAgreed: bool,
    username: string,
    channelId: arrayOf(string),
    isPrivate: bool,
})
